import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getToken } from "@/lib/api";
import panelApi from "@/lib/panelApi";
import { useAuth } from "@/context/AuthContext";

// Panel-only settings (active/inactive salary components, auto-bonus markers,
// Mestre minimum) persisted in OUR backend DB — not localStorage — so they
// survive deploys and are shared across devices.
const DEFAULTS = { disabled_items: {}, auto_bonus_items: {}, mestre_min: null, cost_impact_items: {}, tax_items: {}, quinzena_items: {} };
const Ctx = createContext(null);

export function PayrollSettingsProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!getToken()) {
      setSettings(DEFAULTS);
      setLoading(false);
      return;
    }
    try {
      const { data } = await panelApi.get("/panel/payroll-settings");
      setSettings({ ...DEFAULTS, ...(data || {}) });
    } catch (_) {
      setSettings(DEFAULTS);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [user, refetch]);

  const save = useCallback(async (patch) => {
    const { data } = await panelApi.put("/panel/payroll-settings", patch);
    setSettings({ ...DEFAULTS, ...(data || {}) });
    return data;
  }, []);

  return <Ctx.Provider value={{ settings, loading, refetch, save }}>{children}</Ctx.Provider>;
}

export const usePayrollSettings = () =>
  useContext(Ctx) || { settings: DEFAULTS, loading: false, refetch: () => {}, save: async () => {} };
